import { developmentPlanConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateRespondentsLoading: true, data: '', error: false };

export function updateRespondentsDevelopmentPlan(state = initialState, action) {

    switch (action.type) {
        case developmentPlanConstants.REQUEST_UPDATE_RESPONDENTS:
            return {
                updateRespondentsLoading: true,
                data: '',
                error: false
            };
        case developmentPlanConstants.RECEIVE_UPDATE_RESPONDENTS:
        swal({
            text: 'Min.Respondents Updated Successfully',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                updateRespondentsLoading: false,
                data: action.updateRespondentsData,
                error: false
            };
        case developmentPlanConstants.UPDATE_RESPONDENTS_ERROR:
            return {
                updateRespondentsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/developmentPlan/updateRespondents.reducer.js